export default function SolarPanel({
  width,
  height
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width || 53}
      height={height || 40}
      viewBox="0 0 53 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Solar panel icon</title>
      <g clipPath="url(#clip0_222_4070)">
        <path
          d="M52.9143 27.2531L47.3048 2.82243C46.9285 1.19258 45.3979 0.00878906 43.662 0.00878906H9.33767C7.60179 0.00878906 6.06258 1.19258 5.69488 2.82243L0.0853317 27.2531C-0.162652 28.3253 0.110985 29.4319 0.829281 30.2811C1.53903 31.1304 2.59937 31.6193 3.73667 31.6193H20.9159L23.2846 36.5432H18.0855V40.0088H34.9227V36.5432H29.7236L32.0923 31.6193H49.2715C50.4088 31.6193 51.4606 31.1304 52.1789 30.2811C52.8972 29.4319 53.1623 28.3253 52.9229 27.2531H52.9143ZM27.1668 36.5346H25.8414L23.4727 31.6108H29.5355L27.1668 36.5346ZM50.5542 28.9944C50.2378 29.3633 49.776 29.5777 49.2715 29.5777H3.73667C3.23215 29.5777 2.77039 29.3633 2.454 28.9944C2.14616 28.6256 2.02644 28.1538 2.13761 27.6905L7.73861 3.25991C7.90108 2.54793 8.57662 2.03324 9.33767 2.03324H43.662C44.4316 2.03324 45.0986 2.54793 45.261 3.25991L50.8706 27.6991C50.9732 28.1538 50.862 28.6341 50.5542 29.003V28.9944Z"
          fill="black"
        />
        <path
          d="M18.6842 11.4004H7.82427L6.24231 18.2887H17.4614L18.6842 11.4004Z"
          fill="black"
        />
        <path
          d="M31.8787 3.85156H21.5233L20.4373 9.98495H32.9647L31.8787 3.85156Z"
          fill="black"
        />
        <path
          d="M35.9319 18.2887H46.7577L45.1757 11.4004H34.7177L35.9319 18.2887Z"
          fill="black"
        />
        <path
          d="M34.4355 18.2887L33.2126 11.4004H20.1807L18.9664 18.2887H34.4355Z"
          fill="black"
        />
        <path
          d="M18.7099 19.7041L17.2819 27.759H36.1115L34.6834 19.7041H18.7099Z"
          fill="black"
        />
        <path
          d="M36.1885 19.7041L37.6165 27.759H48.9297L47.0826 19.7041H36.1885Z"
          fill="black"
        />
        <path
          d="M4.07031 27.759H15.7854L17.2134 19.7041H5.92591L4.07031 27.759Z"
          fill="black"
        />
        <path
          d="M44.8508 9.98495L43.4398 3.85156H33.3751L34.4611 9.98495H44.8508Z"
          fill="black"
        />
        <path
          d="M20.0183 3.85156H9.56023L8.14929 9.98495H18.9323L20.0183 3.85156Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_222_4070">
          <rect width="53" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
